import { Text } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 430px;
  gap: 20px;
`

export const Content = styled(Text).attrs({
  variant: 'content-04',
  as: 'div'
})`
  text-align: justify;
`

export const Image = styled.img`
  border-radius: 6px;
`
